/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/chevron_up_medium'
export default icon
